import React from 'react'
import { Text, Flex, Box } from '@chakra-ui/react'

import { Link } from '@/lib/Link'
import { mq } from '@/lib/responsive'
import { Background } from '@/components/Landing/shared'
import { logEvent } from '@/lib/stats/gtm'

const CreatePolicyButton = () => (
  <Link route="selectPolicy" passHref>
    <a
      css={{
        width: 320,
        height: 333,
        margin: '50px 0 100px',

        [mq('sm')]: {
          width: 719,
          height: 232,
        },

        [mq('md+')]: {
          width: '100%',
          height: 248,
        },
      }}
      onClick={() =>
        logEvent({
          ga: {
            category: 'Blog Page',
            action: 'Click create policy banner',
          },
        })
      }
    >
      <Flex
        pos="relative"
        color="#2b2b2b"
        flexDirection="column"
        rounded="16px"
        boxShadow="0 24px 24px 0 rgba(129, 154, 182, 0.24)"
        w="100%"
        h="100%"
        fontWeight="500"
        css={{
          backgroundImage: 'linear-gradient(255deg, #f3f9ff, #f7fbff)',
          padding: '153px 18px 31px 19px',
          alignItems: 'center',

          [mq('sm')]: {
            padding: '31px 33px',
            alignItems: 'flex-start',
          },
        }}
      >
        <Text css={{ fontSize: '24px', [mq('sm')]: { fontSize: '32px' } }}>
          สร้าง Privacy Policy ง่ายๆ
        </Text>
        <Text css={{ fontSize: '16px', [mq('sm')]: { fontSize: '24px' } }}>
          อย่างมืออาชีพ ถูกต้องตาม PDPA
        </Text>
        <Flex
          color="#ffffff"
          justifyContent="center"
          alignItems="center"
          rounded="8px"
          fontSize="20px"
          mt="15px"
          css={{
            backgroundImage: 'linear-gradient(284deg, #00e3ab, #32c4d7)',
            width: 254,
            height: 64,
            padding: '19px 25px 21px 26px',
          }}
        >
          สร้าง Policy ตอนนี้!
        </Flex>
        <Box
          pos="absolute"
          overflow="hidden"
          zIndex={0}
          objectPosition="bottom"
          roundedTopRight="16px"
          css={{
            width: 149,
            height: 114,
            top: 0,
            right: 0,

            [mq('sm')]: {
              width: 200,
              height: 153,
            },

            [mq('md+')]: {
              width: 235,
              height: 188,
            },
          }}
        >
          <Box
            pos="absolute"
            w="278px"
            h="244px"
            css={{
              top: 114 - 244,

              [mq('sm')]: {
                top: 153 - 244,
              },

              [mq('md+')]: {
                top: 188 - 244,
              },
            }}
          >
            <Background src="/images/Landing/group-3-copy.svg" />
          </Box>
        </Box>
        <Box
          pos="absolute"
          css={{
            width: 170 + 88,
            height: 171 + 37,
            top: -40,
            right: 70,

            [mq('sm')]: {
              width: 302 + 88,
              height: 305 + 37,
              top: -25,
              right: -10,
            },

            [mq('sm')]: {
              width: 403,
              height: 375,
              top: -45,
              right: -25,
            },
          }}
          zIndex={0}
        >
          <Background
            src="/images/Landing/add-files-rafiki.svg"
            objectFit="contain"
            objectPosition="right"
          />
        </Box>
      </Flex>
    </a>
  </Link>
)

export default CreatePolicyButton
